import { fetchAuthSession, fetchUserAttributes } from "@aws-amplify/auth";
import { resolveSessionForType } from "./resolveSession";

/**
 * Resolve the current Reader from the shared Amplify/Cognito cookie session.
 * Origin-specific localStorage and sessionStorage values are intentionally not
 * used as identity sources.
 */
export const getCurrentReader = async () => {
  try {
    const { data: [attributes, session] } = await resolveSessionForType("reader", {
      persist: false,
      restore: true,
      read: () => Promise.all([fetchUserAttributes(), fetchAuthSession()]),
    });

    const readerSub = attributes?.sub;
    if (!readerSub) return null;

    return {
      readerSub,
      email: attributes?.email || null,
      firstName: attributes?.given_name || null,
      lastName: attributes?.family_name || null,
      idToken: session?.tokens?.idToken?.toString?.() || null,
    };
  } catch {
    return null;
  }
};
